import { useScreen } from '../../hooks/useScreen';
import { LogoBox, MainBox } from './PescaChacoLogo.styles';

const PescaChacoLogo = () => {
  const { isMobile } = useScreen();

  return (
    <MainBox id='pesca-chaco-logo'>
      <LogoBox className={isMobile ? 'mobile' : 'desktop'} />
    </MainBox>
  );
};

export default PescaChacoLogo;
